import React from 'react';
import { formatTextLengthStatLabels } from '../utils/word-count';

const RIGHT_SIDEBAR_WIDTH_ICON = '3rem';

type EditorStatsOverlayProps = {
  wordCount: number;
  readingTime: number;
  pageCount: number;
  selectedWordCount: number;
  selectedReadingTime: number;
  selectedPageCount: number;
  t: (key: string) => string;
};

export const EditorStatsOverlay: React.FC<EditorStatsOverlayProps> = React.memo(({
  wordCount,
  readingTime,
  pageCount,
  selectedWordCount,
  selectedReadingTime,
  selectedPageCount,
  t,
}) => {
  const rightOffset = `calc(${RIGHT_SIDEBAR_WIDTH_ICON} + 0.5rem)`;
  const hasSelection = selectedWordCount > 0;
  const documentLabels = formatTextLengthStatLabels(
    { wordCount, readingTime, pageCount },
    t,
  );
  const selectionLabels = formatTextLengthStatLabels(
    {
      wordCount: selectedWordCount,
      readingTime: selectedReadingTime,
      pageCount: selectedPageCount,
    },
    t,
  );

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .editor-stats-overlay {
            right: 0.125rem !important;
          }
        }
      `}</style>
      <div
        className="editor-stats-overlay floating-editor-control"
        style={{
          position: 'fixed',
          bottom: '0.5rem',
          right: rightOffset,
          padding: '0.5rem 0.75rem',
          fontSize: '0.75rem',
          color: 'var(--foreground)',
          pointerEvents: 'none',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.25rem',
        }}
      >
      {hasSelection && (
        <div style={{ textAlign: 'right' }}>
          <span>{t('selection')}: </span>
          <span>
            {selectionLabels.words}
          </span>
          <span style={{ margin: '0 0.5rem' }}>|</span>
          <span>
            {selectionLabels.pages}
          </span>
          <span style={{ margin: '0 0.5rem' }}>|</span>
          <span>
            {selectionLabels.minutes}
          </span>
        </div>
      )}
      <div style={{ textAlign: 'right' }}>
        <span>
          {documentLabels.words}
        </span>
        <span style={{ margin: '0 0.5rem' }}>|</span>
        <span>
          {documentLabels.minutes}
        </span>
        <span style={{ margin: '0 0.5rem' }}>|</span>
        <span>
          {documentLabels.pages}
        </span>
      </div>
    </div>
    </>
  );
});

